import {subjectRemarks} from "@/api/subjects";

export default {
  name: 'Remark',

  components: {},

  mixins: [],

  props: {
    subject: {
      type: Object,
      require: true
    },
    project: {
      type: Object,
      require: true
    },
  },

  data() {
    return {
      remarks:""
    }
  },

  computed: {},

  watch: {},

  created() {
  },

  methods: {
    // 提交下一访事
    goNextVisit() {
      const params = {
        project_id: this.project.id,
        id: this.subject.id,
        remarks: this.subject.remarks
      }
      subjectRemarks(this, params, (res) => {
        this.$emit('nextVisitOk')
      })
    }
  }
}
